import DapDSIconButton from './icon-button.component'

export * from './icon-button.component'
export default DapDSIconButton

DapDSIconButton.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-button': DapDSIconButton
  }
}
